<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">약속상품 제조하기</h2>
          <article>
            <ul class="search_filter">
              <li>
                <p>약속상품명</p>
                <input type="text" placeholder="약속상품명을 입력하세요" class="form_control" v-model="searchInfo.wrapperName">
              </li>
              <li>
                <p>상품타입</p>
                <div class="form_select">
                  <b-form-select v-model="searchInfo.goodsType" >
                    <b-form-select-option value="">전체</b-form-select-option>
                    <b-form-select-option v-for="(item, index) in goodsTypeList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                  </b-form-select>
                </div>
              </li>
              <li>
                <p>처리상태</p>
                <div class="form_select">
                  <b-form-select v-model="searchInfo.workStatus" >
                    <b-form-select-option value="">전체</b-form-select-option>
                    <b-form-select-option v-for="(item, index) in workStatusList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                  </b-form-select>
                </div>
              </li>
              <li>
                <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
              </li>
            </ul>
          </article>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="list no_view">
              <thead>
                <tr>
                    <th>No</th>
                    <th>약속상품명</th>
                    <th>상품타입</th>
                    <th>조제단위</th>
                    <th>제조량</th>
                    <th>처리</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="promiseGoosWrhsList.length == 0">
                    <td colspan="6"><span>데이터가 없습니다.</span></td>
                </tr>
                <tr v-for="(item, index) in promiseGoosWrhsList" :key="index" :class="{ on:item.promise_goods_cd === choose_wrapper_cd }" @click="fn_promiseGddos_choise(item.promise_goods_cd)">
                  <td><span>{{ index + 1 + ((searchInfo.pageInfo.page-1) * searchInfo.pageInfo.pageSize)  }}</span></td>
                  <td><span>{{ item.promise_goods_nm }}</span></td>
                  <td><span>{{ item.promise_goods_type_nm }}</span></td>
                  <td><span>{{ item.prepare_unit_nm }}</span></td>
                  <td><span>{{ item.produce_quantity }}</span></td>
                  <td>
                    <div class="form_inline">
                    <button v-if="item.work_status === 'P1'" :class="'bdge bd_blue'" @click="fn_change_ststus(item)">조제접수</button>
                    <button v-else>완료</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo="searchInfo.pageInfo"  v-show="pagingShow"/>
          </div>
        </section>
      </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import commonUtil from "@/mixin/commonUtil";
    import Pagination from "@/components/AdminPagination.vue"

    export default {
        name: 'PromiseGoodsProductMngt',
        components: {
            Pagination,
        },
        mixins: [commonUtil],
        data() {
        return {
                goodsTypeList : [],       // 상품타입 리스트
                workStatusList : [],      
                searchInfo : {
                  promiseGoodsNm : '',
                  goodsType : '',
                  workStatus : '',
                  pageInfo : {
                    page : 1,
                    pageSize : 10,
                    totPage : 0
                  }                
                },
                choose_wrapper_cd : '',
                pagingShow : false,
                wrapperClassList : [],
                promiseGoosWrhsList: [],
                selected: null
            }
        },
        async created(){
          //공통코드 - 상품타입가져오기
          this.goodsTypeList = await this.getCode('GC00000008');  

          //공통코드 - 업무상태코드가져오기(신청중,완료중사용)
          let codeList = [];
          codeList = await this.getCode('GC00000006'); 
          for(let i = 0; i < codeList.length ; i++){
            if(codeList[i].dtl_code == 'P1' || codeList[i].dtl_code == 'P8'){
              this.workStatusList.push(codeList[i]);
            }
          }

          let searchInfoStore = this.$store.getters['commonStore/getSearchInfo'];             
          if(searchInfoStore != null && searchInfoStore != {}){
              this.searchInfo = searchInfoStore
          }

          this.fn_search();
        },
        methods : {
            fn_search(){
                console.log("@@@ search : ",this.searchInfo);

                // 검색 정보 저장
                this.$store.dispatch('commonStore/setSearchInfo', this.searchInfo); 

                axios
                    .post("/api/admin/promiseGoodsWrhs/getPromiseGoodsMakeList", this.searchInfo)
                    .then((res) => {
                        console.log("@@@@ res : %o",res);
                        this.promiseGoosWrhsList = res.data.promiseWhrsList;

                        console.log("@@@@ promiseWhrsList : %o",this.promiseWhrsList);

                        this.searchInfo.pageInfo.totPage = res.data.totCnt;
                        
                        if(this.searchInfo.pageInfo.totPage> 0){
                            this.pagingShow = true;                          
                        }                        

                    })
                    .catch((err) => console.log(err));
            },
            // 생산할 약속상품 선택시
            fn_promiseGddos_choise(wrapper_cd){
              this.choose_wrapper_cd = wrapper_cd;
            },
            fn_move_reg_page(){

                if(this.choose_wrapper_cd == ''){
                  alert("제조할 약속상품을 선택하세요");
                }else{
                  this.$store.dispatch('commonStore/setMainCode', this.choose_wrapper_cd);
                  this.$router.push("/admin/promise/promiseGoodsWrhstReg");
                }
            },
            fn_move_dtl_page(wrapperWrhsCd){
                this.$store.dispatch('commonStore/setMainCode', wrapperWrhsCd);
                this.$store.dispatch('commonStore/setStatus', 'M');  
                
                
                this.$router.push("/admin/wrapper/WrapperWrhsMngtReg");			
            },
            fn_change_ststus(item){
                
                axios
                    .post("/api/admin/promiseGoodsWrhs/updateWorkStatus", item)
                    .then((res) => {
                        alert("처리되었습니다");
                        this.fn_search();
                    })
                    .catch((err) => console.log(err));
            }
        }
        
    }
</script>